import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>About Us</h3>
          <p>Kalinga Crafts Store brings authentic handmade and manufactured products directly from Producers to your doorstep.</p>
        </div>

        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/products">Products</Link></li>
            <li><Link to="/contact">Contact</Link></li>
            <li><Link to="/orders">Orders</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Policies</h3>
          <ul>
            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            <li><Link to="/terms-of-service">Terms of Service</Link></li>
            <li><Link to="/refund-policy">Refund Policy</Link></li>
            <li><Link to="/shipping-policy">Shipping Policy</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Categories</h3>
          <ul>
            <li><Link to="/products?category=stationary">Stationary</Link></li>
            <li><Link to="/products?category=textiles">Textiles & Fabrics</Link></li>
            <li><Link to="/products?category=pottery">Pottery & Ceramics</Link></li>
            <li><Link to="/products?category=electronics">Electronics</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Contact Info</h3>
          <p>Email: support@kalingastore.shop</p>
          <p>Phone: +91 7217786935</p>
          <p>Location: Ghaziabad, Uttar Pradesh, India</p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; 2025 Kalinga Crafts Store. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
